export default "__VITE_ASSET__CUqkD5rJ__"